/** Area code region names - English */
export default {
  areaCodes: {
  "1": "China",
  "2": "Hong Kong",
  "3": "Taiwan",
  "4": "United States",
  "7": "Macau",
  "8": "Andorra",
  "9": "United Arab Emirates",
  "10": "Afghanistan",
  "11": "Antigua and Barbuda",
  "12": "Anguilla",
  "13": "Albania",
  "14": "Armenia",
  "15": "Ascension",
  "16": "Angola",
  "17": "Argentina",
  "18": "Austria",
  "19": "Australia",
  "20": "Azerbaijan",
  "21": "Barbados",
  "22": "Bangladesh",
  "23": "Belgium",
  "24": "Burkina Faso",
  "25": "Bulgaria",
  "26": "Bahrain",
  "27": "Burundi",
  "28": "Benin",
  "29": "Palestine",
  "30": "Bermuda",
  "31": "Brunei",
  "32": "Bolivia",
  "33": "Brazil",
  "34": "Bahamas",
  "35": "Botswana",
  "36": "Belarus",
  "37": "Belize",
  "38": "Canada",
  "39": "Cayman Islands",
  "40": "Central African Republic",
  "41": "Congo",
  "42": "Switzerland",
  "43": "Cook Islands",
  "44": "Chile",
  "45": "Cameroon",
  "46": "Colombia",
  "47": "Costa Rica",
  "48": "Cuba",
  "49": "Cyprus",
  "50": "Czech Republic",
  "51": "Germany",
  "52": "Djibouti",
  "53": "Denmark",
  "54": "Dominican Republic",
  "55": "Algeria",
  "56": "Ecuador",
  "57": "Estonia",
  "58": "Egypt",
  "59": "Spain",
  "60": "Ethiopia",
  "61": "Finland",
  "62": "Fiji",
  "63": "France",
  "64": "Gabon",
  "65": "United Kingdom",
  "66": "Grenada",
  "67": "Georgia",
  "68": "French Guiana",
  "69": "Ghana",
  "70": "Gibraltar",
  "71": "Gambia",
  "72": "Guinea",
  "73": "Greece",
  "74": "Guatemala",
  "75": "Guam",
  "76": "Guyana",
  "77": "Honduras",
  "78": "Haiti",
  "79": "Hungary",
  "80": "Indonesia",
  "81": "Ireland",
  "82": "Israel",
  "83": "India",
  "84": "Iraq",
  "85": "Iran",
  "86": "Iceland",
  "87": "Italy",
  "88": "Côte d'Ivoire",
  "89": "Jamaica",
  "90": "Jordan",
  "91": "Japan",
  "92": "Kenya",
  "93": "Kyrgyzstan",
  "94": "Cambodia",
  "95": "North Korea",
  "96": "South Korea",
  "97": "Côte d'Ivoire",
  "98": "Kuwait",
  "99": "Kazakhstan",
  "100": "Laos",
  "101": "Lebanon",
  "102": "Saint Lucia",
  "103": "Liechtenstein",
  "104": "Sri Lanka",
  "105": "Liberia",
  "106": "Lesotho",
  "107": "Lithuania",
  "108": "Luxembourg",
  "109": "Latvia",
  "110": "Libya",
  "111": "Morocco",
  "112": "Monaco",
  "113": "Moldova",
  "114": "Madagascar",
  "115": "Mali",
  "116": "Myanmar",
  "117": "Mongolia",
  "118": "Montserrat",
  "119": "Malta",
  "120": "Northern Mariana Islands",
  "121": "Martinique",
  "122": "Mauritius",
  "123": "Maldives",
  "124": "Malawi",
  "125": "Mexico",
  "126": "Malaysia",
  "127": "Mozambique",
  "128": "Namibia",
  "129": "Niger",
  "130": "Nigeria",
  "131": "Nicaragua",
  "132": "Netherlands",
  "133": "Norway",
  "134": "Nepal",
  "135": "Netherlands Antilles",
  "136": "Nauru",
  "137": "New Zealand",
  "138": "Oman",
  "139": "Panama",
  "140": "Peru",
  "141": "French Polynesia",
  "142": "Papua New Guinea",
  "143": "Philippines",
  "144": "Pakistan",
  "145": "Poland",
  "146": "Puerto Rico",
  "147": "Portugal",
  "148": "Paraguay",
  "149": "Qatar",
  "150": "Réunion",
  "151": "Romania",
  "152": "Russia",
  "153": "Saudi Arabia",
  "154": "Solomon Islands",
  "155": "Seychelles",
  "156": "Sudan",
  "157": "Sweden",
  "158": "Singapore",
  "159": "Slovenia",
  "160": "Slovakia",
  "161": "Sierra Leone",
  "162": "San Marino",
  "163": "American Samoa",
  "164": "Samoa",
  "165": "Senegal",
  "166": "Somalia",
  "167": "Suriname",
  "168": "São Tomé and Príncipe",
  "169": "El Salvador",
  "170": "Syria",
  "171": "Eswatini",
  "172": "Chad",
  "173": "Togo",
  "174": "Thailand",
  "175": "Tajikistan",
  "176": "Turkmenistan",
  "177": "Tunisia",
  "178": "Tonga",
  "179": "Turkey",
  "180": "Trinidad and Tobago",
  "182": "Tanzania",
  "183": "Ukraine",
  "184": "Uganda",
  "186": "Uruguay",
  "187": "Uzbekistan",
  "188": "Saint Vincent and the Grenadines",
  "189": "Venezuela",
  "190": "Vietnam",
  "191": "Yemen",
  "192": "Yugoslavia",
  "193": "South Africa",
  "194": "Zambia",
  "195": "DR Congo",
  "196": "Zimbabwe"
}
};
